import React from 'react';
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
interface ChartCardProps {
  title: string;
  subtitle?: string;
  data: any[];
  type: 'line' | 'bar';
  dataKeys: string[];
  colors?: string[];
  height?: number;
}
const ChartCard: React.FC<ChartCardProps> = ({
  title,
  subtitle,
  data,
  type,
  dataKeys,
  colors = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444'],
  height = 300
}) => {
  const renderChart = () => {
    if (type === 'line') {
      return <LineChart data={data} margin={{
        top: 10,
        right: 30,
        left: 0,
        bottom: 0
      }} data-id="element-31">
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" data-id="element-32" />
          <XAxis dataKey="name" stroke="#9CA3AF" data-id="element-33" />
          <YAxis stroke="#9CA3AF" data-id="element-34" />
          <Tooltip contentStyle={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '0.375rem'
        }} data-id="element-35" />
          <Legend data-id="element-36" />
          {dataKeys.map((key, index) => <Line key={key} type="monotone" dataKey={key} stroke={colors[index % colors.length]} strokeWidth={2} dot={{
          r: 3
        }} activeDot={{
          r: 5
        }} data-id="element-37" />)}
        </LineChart>;
    } else if (type === 'bar') {
      return <BarChart data={data} margin={{
        top: 10,
        right: 30,
        left: 0,
        bottom: 0
      }} data-id="element-38">
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" data-id="element-39" />
          <XAxis dataKey="name" stroke="#9CA3AF" data-id="element-40" />
          <YAxis stroke="#9CA3AF" data-id="element-41" />
          <Tooltip contentStyle={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '0.375rem'
        }} data-id="element-42" />
          <Legend data-id="element-43" />
          {dataKeys.map((key, index) => <Bar key={key} dataKey={key} fill={colors[index % colors.length]} radius={[4, 4, 0, 0]} data-id="element-44" />)}
        </BarChart>;
    }
    return null;
  };
  return <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-45">
      <div className="mb-4" data-id="element-46">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white" data-id="element-47">
          {title}
        </h3>
        {subtitle && <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-48">{subtitle}</p>}
      </div>
      <div className="h-[300px]" data-id="element-49">
        <ResponsiveContainer width="100%" height="100%" data-id="element-50">
          {renderChart()}
        </ResponsiveContainer>
      </div>
    </div>;
};
export default ChartCard;